import React from 'react';
import {  useQueryWithStore, SelectInput, required } from 'react-admin';
import jwt_decode from 'jwt-decode'
import { useForm } from 'react-final-form';


const Users = ({rest,...props }) => {
    const form = useForm(props.form);
   // console.log(moment(props.value).format('MMMM DD YYYY'))
   let cid = ((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).cid : '1'  
    const { loaded, data: sets } = useQueryWithStore({
        type: 'getList',
        resource: 'users',
        payload: {
            filter: {
                cid: cid
            },
            sort: { field: 'full_name', order: 'ASC' },
            pagination: { page: 1, perPage: 100 },
        },
    });

    
    if (!loaded) return null;
    var choiceSet = []
    const choice = sets? sets.map(record => ( choiceSet.push({
                                                    id: record.id,
                                                    name: record.full_name
                                                }))): []

    
    return (
        <div>
            <SelectInput
                    source="user_id"
                    choices={choiceSet} 
                    label = 'Employee'
                    validate={required()}
                 {...rest}
            />
        </div>

        
    );
};

export default Users